/* eslint-disable import/prefer-default-export */
/**
 * Listado de roles de usuario
 * @readonly
 */
export const ROL_OPTIONS = [
  { label: 'Autoridad', value: 'AUTORIDAD' },
  { label: 'Administrador', value: 'ADMINISTRADOR' },
  { label: 'Denunciante', value: 'DENUNCIANTE' },
  { label: 'Gestor', value: 'RESPONSABLE' },
];
